export const calculateCourseTime = (totalTime: number) => {
  const timeInHours = totalTime / 60 / 60
  if (timeInHours < 1) return 1
  if (timeInHours % 0.5 < 0.5) return timeInHours - (timeInHours % 0.5)
  return timeInHours - (timeInHours % 0.5) + 0.5
}
